module.exports = __webpack_public_path__ + "img/v-card.9882078a.png";